import { defineStore, acceptHMRUpdate } from 'pinia'
import { integer } from 'vscode-languageserver-types'
import axios from '~/utils/api'
import { VacancyFetchStatus } from '~/utils/enums'

export const useVacancyStore = defineStore({
  id: 'vacancy',
  state: () => {
    return {
      vacancies: [],
      currentVacancy: null,
      currentVacancyList: null,
      currentVacanciesByVacancyList: null,
      currentVacanciesByVacancyListTotalPages: null,
      addresses: []
    } as any
  },
  actions: {
    async fetchByCompanyId(companyId: number) {
      try {
        const { data } = await axios.get(`companies/${companyId}/active-vacancies`)

        this.$patch({
          vacancies: data.data
        })

        return VacancyFetchStatus.SUCCESS
      } catch (e) {
        return VacancyFetchStatus.FAILURE
      }
    },
    async fetchVacancyById(vacancyId: string) {
      const { data } = await axios.get(`vacancies/${vacancyId}`)

      this.$patch({
        currentVacancy: data.data
      })

      return this.currentVacancy
    },
    async fetchVacancyList(vacancyListId: number) {
      const { data } = await axios.get(`vacancy_lists/${vacancyListId}`)

      this.$patch({
        currentVacancyList: data?.data
      })
    },
    async fetchVacanciesByVacanciesListId(vacancyListId: number) {
      const { data } = await axios.get(
          `vacancy_lists/${vacancyListId}/vacancies/public?page=1&perPage=15`
      )

      this.$patch({
        currentVacanciesByVacancyList: data?.data,
        currentVacanciesByVacancyListTotalPages: data?.meta?.last_page
      })
    },
    async fetchAndAddVacanciesByVacanciesListId(vacancyListId: number, page: integer) {
      const { data } = await axios.get(
          `vacancy_lists/${vacancyListId}/vacancies/public?page=${page}&perPage=15`
      )

      this.$patch({
        currentVacanciesByVacancyList: this.currentVacanciesByVacancyList.concat(data?.data)
      })
    },
    async getAddressDistances(companyId: number, long: integer, lat: integer) {
      try {
        const { data } = await axios.post('vacancies/address_distances', {
          companyId,
          long,
          lat
        })

        this.$patch({
          addresses: data
        })

        return VacancyFetchStatus.SUCCESS
      } catch (e) {
        return VacancyFetchStatus.FAILURE
      }
    },
    getMockVacancy() {
      const mockVacancy = {
        id: 953,
        companyId: 634,
        status: 'active',
        title: 'jkasalfkasbdkahjS asdhkbj D',
        completed: true,
        description: '<p>Huntica.works - сервис для автоматизированных онлайн видео-собеседований. Работодатель размещает вакансии в сервисе Huntica, после чего, соискатели проходят видео-интервью по заранее продуманному работодателем сценарию с виртуальным персонажем. Далее HR специалист компании просматривает готовые видео интервью и принимает решение о найме тех или иных кандидатов. </p><p>Система предназначена для того, чтобы снять с HR специалистов, а также руководителей отделов компаний необходимость проводить первое интервью с соискателем..</p><p></p><p></p><p>Стоимость обслуживания вы можете посмотреть в разделе Тарифы.</p><ul><li>Тариф «Промо» – подходит для того, чтобы попробовать сервис и понять, насколько формат онлайн-собеседований вписывается в ваш процесс найма. В промо-тарифе отсутствуют некоторые возможности платных тарифов (например, СМС-оповещения).</li><li>Тариф «Малый Бизнес» - подходит для небольших компаний. Есть возможность оплаты банковской картой, но перевод по безналу недоступен.</li><li>Тарифы «Стандартный» и «Расширенный» - полнофункциональные тарифы для крупных компаний и HR-агентств. Есть возможность оплаты по безналу. Доступ ко всем опциям сервиса, которые отсутствуют в младших тарифах.</li><li>Тариф «Безлимитный» подходит для массового найма. Например, это могут быть задачи по отбору на программы стажировок.</li></ul><p></p><p></p>',
        createdAt: '2022-06-03T16:22:06+00:00',
        publishedFrom: '2022-06-03T16:22:18+00:00',
        publishedTill: '2022-07-18T16:22:18+00:00',
        archivedAt: null,
        skills: [
          'наавык1',
          'навык2',
          'навык3',
          'наавык4',
          'навык5',
          'навык6',
          'наавык7',
          'навык8',
          'навык9'
        ],
        salaryFrom: {
          currency: 'USD',
          amount: '50000',
          decimal: '500.00',
          formatted: {
            decimal: '500',
            currency: '$'
          }
        },
        salaryTo: {
          currency: 'USD',
          amount: '100000',
          decimal: '1000.00',
          formatted: {
            decimal: '1 000',
            currency: '$'
          }
        },
        salaryType: 'gross',
        salary: {
          id: 263,
          vacancyId: 953,
          from: 500,
          to: 1000,
          currency: 'USD',
          payFrequency: 'month',
          payType: 'gross'
        },
        experience: 'beginner',
        schedule: 'regular',
        employment: 'fulltime',
        contactPerson: {
          id: 619,
          name: 'test test',
          phone: '+79878242763',
          email: 'sgjakskfbdhskd@alkjndsadasd.sadjhsd',
          comment: null
        },
        address: {
          id: 466,
          placeId: 'ChIJybDUc_xKtUYRTM9XV8zWRD0',
          city: 'Москва',
          address: 'Москва, Россия',
          latitude: 55.755826,
          longitude: 37.6173,
          coordinates: {
            latitude: 55.755826,
            longitude: 37.6173
          }
        },
        addressId: 466,
        script: {
          id: 953,
          vacancyId: 953,
          interviewerId: 2,
          interviewer: {
            id: 2,
            locale: 'ru',
            name: 'Александр Демидов',
            videoUrl: 'https://s3.huntica.works/media-public/interviewers/ru.demidov',
            photo: null,
            photos: [],
            videoTimestamps: [
              {
                id: 8,
                type: 'hello',
                startTime: 0,
                speechStopTime: 47,
                stopTime: 51
              },
              {
                id: 9,
                type: 'welcome',
                startTime: 71,
                speechStopTime: 96,
                stopTime: 100
              },
              {
                id: 10,
                type: 'resume',
                startTime: 113,
                speechStopTime: 120,
                stopTime: 124
              },
              {
                id: 11,
                type: 'goodbye',
                startTime: 124,
                speechStopTime: 140,
                stopTime: 144
              },
              {
                id: 15,
                type: 'text_question',
                startTime: 266,
                speechStopTime: 271,
                stopTime: 275
              },
              {
                id: 16,
                type: 'listening',
                startTime: 3677,
                speechStopTime: 3677,
                stopTime: 3797
              },
              {
                id: 12,
                type: 'text_question',
                startTime: 248,
                speechStopTime: 252,
                stopTime: 256
              },
              {
                id: 13,
                type: 'text_question',
                startTime: 256,
                speechStopTime: 262,
                stopTime: 266
              },
              {
                id: 14,
                type: 'text_question',
                startTime: 266,
                speechStopTime: 271,
                stopTime: 275
              }
            ]
          },
          questions: [
            {
              id: 282,
              questionId: 1,
              type: 'video_question',
              file: '1.m4s',
              question: 'Какое у вас образование? Назовите, пожалуйста, учебное заведение и специальность.',
              interviewerId: 2,
              duration: null,
              startTime: 275,
              speechStopTime: 281,
              stopTime: 285
            },
            {
              id: 358,
              questionId: 79,
              type: 'video_question',
              file: '79.m4s',
              question: 'Чем вас привлекает работа в нашей компании?',
              interviewerId: 2,
              duration: null,
              startTime: 1037,
              speechStopTime: 1041,
              stopTime: 1045
            },
            {
              id: 390,
              questionId: 111,
              type: 'video_question',
              file: '111.m4s',
              question: 'Почему вы считаете, что у вас получится справиться с задачами нашей вакансии?',
              interviewerId: 2,
              duration: null,
              startTime: 1332,
              speechStopTime: 1338,
              stopTime: 1342
            },
            {
              id: 508,
              questionId: 229,
              type: 'video_question',
              file: '229.m4s',
              question: 'Опыт продаж каких товаров или услуг у вас есть?',
              interviewerId: 2,
              duration: null,
              startTime: 2475,
              speechStopTime: 2480,
              stopTime: 2484
            },
            {
              id: 392,
              questionId: 113,
              type: 'video_question',
              file: '113.m4s',
              question: 'Расскажите, пожалуйста, подробнее о вашей роли и зоне ответственности на предыдущем месте работы',
              interviewerId: 2,
              duration: null,
              startTime: 1350,
              speechStopTime: 1358,
              stopTime: 1362
            },
            {
              id: 322,
              questionId: 43,
              type: 'video_question',
              file: '43.m4s',
              question: 'Какие задачи на предыдущем месте работы вы выполняли с удовольствием, а какие нет?',
              interviewerId: 2,
              duration: null,
              startTime: 660,
              speechStopTime: 667,
              stopTime: 671
            },
            {
              id: 459,
              questionId: 180,
              type: 'video_question',
              file: '180.m4s',
              question: 'Вы больше работали с холодными звонками, тёплой базой или обрабатывали входящие звонки?',
              interviewerId: 2,
              duration: null,
              startTime: 1987,
              speechStopTime: 1994,
              stopTime: 1998
            },
            {
              id: 457,
              questionId: 178,
              type: 'video_question',
              file: '178.m4s',
              question: 'Какой у вас был план и KPI?',
              interviewerId: 2,
              duration: null,
              startTime: 1971,
              speechStopTime: 1975,
              stopTime: 1979
            },
            {
              id: 472,
              questionId: 193,
              type: 'video_question',
              file: '193.m4s',
              question: 'Входило ли в ваши обязанности формирование ежемесячной или еженедельной отчётности?',
              interviewerId: 2,
              duration: null,
              startTime: 2115,
              speechStopTime: 2122,
              stopTime: 2126
            },
            {
              id: 460,
              questionId: 181,
              type: 'video_question',
              file: '181.m4s',
              question: 'Удавалось ли вам повышать чек во время работы с одним клиентом? Приведите пример.',
              interviewerId: 2,
              duration: null,
              startTime: 1998,
              speechStopTime: 2005,
              stopTime: 2009
            },
            {
              id: 510,
              questionId: 231,
              type: 'video_question',
              file: '231.m4s',
              question: 'Какими техниками продаж вы владеете? Какие применяете чаще?',
              interviewerId: 2,
              duration: null,
              startTime: 2492,
              speechStopTime: 2498,
              stopTime: 2502
            },
            {
              id: 445,
              questionId: 166,
              type: 'video_question',
              file: '166.m4s',
              question: 'Перечислите этапы продаж',
              interviewerId: 2,
              duration: null,
              startTime: 1868,
              speechStopTime: 1872,
              stopTime: 1875
            },
            {
              id: 451,
              questionId: 172,
              type: 'video_question',
              file: '172.m4s',
              question: 'Какие у вас сильные стороны, как у специалиста по продажам',
              interviewerId: 2,
              duration: null,
              startTime: 1919,
              speechStopTime: 1924,
              stopTime: 1928
            },
            {
              id: 367,
              questionId: 88,
              type: 'video_question',
              file: '88.m4s',
              question: 'Какие специальные программы или сервисы вы используете в работе?',
              interviewerId: 2,
              duration: null,
              startTime: 1118,
              speechStopTime: 1124,
              stopTime: 1128
            },
            {
              id: 316,
              questionId: 37,
              type: 'video_question',
              file: '37.m4s',
              question: 'Почему вы уходили с прежних мест работы?',
              interviewerId: 2,
              duration: null,
              startTime: 606,
              speechStopTime: 610,
              stopTime: 614
            },
            {
              id: 516,
              questionId: 237,
              type: 'video_question',
              file: '237.m4s',
              question: 'Какие у вас ожидания от работы у нас в первый месяц?',
              interviewerId: 2,
              duration: null,
              startTime: 2554,
              speechStopTime: 2559,
              stopTime: 2563
            },
            {
              id: 362,
              questionId: 83,
              type: 'video_question',
              file: '83.m4s',
              question: 'В какие сроки вы могли бы приступить к работе?',
              interviewerId: 2,
              duration: null,
              startTime: 1079,
              speechStopTime: 1084,
              stopTime: 1088
            }
          ]
        },
        faq: [],
        visibility: 'all',
        permissions: {
          storeCandidates: true
        },
        settings: {
          id: 3220,
          vacancyId: 953,
          autoInvitation: false,
          notificationMethod: 'email'
        },
        externalVacancies: [],
        link: 'https://huntica.online/v/953',
        creator: {
          id: 773,
          email: 'sgjakskfbdhskd@alkjndsadasd.sadjhsd',
          firstName: 'test',
          lastName: 'test',
          phone: '+79878242763',
          emailVerified: false,
          companyId: 634,
          settings: {
            id: 654,
            userId: 773,
            locale: 'ru',
            integrationVacancyDialog: null,
            integrationKanbanDialog: null,
            integrationKanbanDialogAuto: null
          },
          needToChangePassword: false,
          position: null,
          isSuperUser: true,
          isCurrentUser: false,
          hasActiveVacancies: true,
          hasArchiveVacancies: false
        },
        creatorName: 'test test'
      }

      this.$patch({
        currentVacancy: mockVacancy
      })
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVacancyStore, import.meta.hot))
}
